import { render, staticRenderFns } from "./VitalSign.vue?vue&type=template&id=108bb71e"
import script from "./VitalSign.vue?vue&type=script&lang=js"
export * from "./VitalSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports